<template>
  <div class="havya-aboutUs">
    <menuBox :step="2"></menuBox>
    <div class="havya-aboutusbox">
      <div class="title">
        <p>Explore The World</p>
        <span>Welcome to HAVYA SYSTEMS LLP</span>
        <p>Help you manage and plan your trip</p>
      </div>
    </div>
    <div class="countries-box">
      <div class="bt">Learn About India</div>
      <div class="listBox">
        <div class="list">
          <img src="../assets/countries1.png" alt="">
          <p>Indian food</p>
        </div>
        <div class="list">
          <img src="../assets/countries2.png" alt="">
          <p>Mumbai</p>
        </div>
        <div class="list">
          <img src="../assets/countries3.png" alt="">
          <p>Ganges River</p>
        </div>
        <div class="list">
          <img src="../assets/countries4.png" alt="">
          <p>Religious Culture</p>
        </div>
      </div>
    </div>
    <div class="weekly-box">
      <div class="title">Holiday travel booking</div>
      <div class="text">Book in advance to help you plan your travel plans</div>
      <div class="itemBox">
        <div class="item">
          <img src="../assets/weekly1.png" alt="">
          <div class="mumbai">
            <div class="mumbai-bt">Greece</div>
            <div class="mumbai-title">Itinerary includes:</div>
            <div class="mumbai-text">5Accommodation and itinerary for 7 days and 6 nights
              Round trip air tickets
              Attraction tickets</div>
            <div class="btn" @click="step">Book now</div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/weekly2.png" alt="">
          <div class="mumbai">
            <div class="mumbai-bt">Mumbai</div>
            <div class="mumbai-title">Itinerary includes:</div>
            <div class="mumbai-text">2 days and 1 night accommodation and itinerary
              Round trip bus ticket
              Attraction tickets</div>
            <div class="btn" @click="step">Book now
            </div>
          </div>
        </div>
        <div class="item">
          <img src="../assets/weekly3.png" alt="">
          <div class="mumbai">
            <div class="mumbai-bt">Thailand</div>
            <div class="mumbai-title">Itinerary includes:</div>
            <div class="mumbai-text">Accommodation and itinerary for 5 days and 4 nights
              Round trip air tickets
              Attraction tickets</div>
            <div class="btn" @click="step">Book Now</div>
          </div>
        </div>
      </div>
    </div>
    <div class="country-box">
      <img src="../assets/country.png" alt="">
      <div class="right">
        <div class="title">Explore a bigger world</div>
        <div class="text">Pack your bags and get ready to go and discover the beauty of the local area</div>
        <div class="lineBox">
          <div class="item">
            <p>150.640+</p>
            <span>Total Guests Yearly</span>
          </div>
          <div class="item">
            <p>175.000+</p>
            <span>Amazing Accomoditations</span>
          </div>
        </div>
        <div class="lineBox">
          <div class="item">
            <p>12.560+</p>
            <span>Amazing Places</span>
          </div>
          <div class="item">
            <p>240.580+</p>
            <span>Different Check-ins Yearly</span>
          </div>
        </div>
      </div>
    </div>
    <footerBox></footerBox>
  </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
  name: "App",
  components: {
    menuBox,
    footerBox,
  },
  data() {
    return {};
  },
  mounted() { },
  methods: {
    step() {
      this.$router.push({ path: "services" });
    },
  },
};
</script>
<style lang="less" scoped>
.havya-aboutusbox {
  background-image: url(../assets/aboutUs.png);
  width: 100%;
  height: 700px;
  background-size: 100% 100%;
  overflow: hidden;

  .title {
    padding: 226px 360px 0;
    text-align: center;

    p {
      font-size: 20px;
      font-family: ArialMT;
      color: #FFFFFF;
    }

    span {
      margin: 8px 0;
      font-size: 72px;
      font-family: Arial, Arial;
      font-weight: 700;
      color: #FFFFFF;
      line-height: 101px;
    }
  }
}

.countries-box {
  position: relative;
  top: -50px;
  margin: 0 360px;
  padding: 56px 48px;
  background: #FFFFFF;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
  border-radius: 24px;
  box-sizing: border-box;

  .bt {
    margin-bottom: 27px;
    font-size: 32px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #333333
  }

  .listBox {
    display: flex;

    .list {
      margin-right: 20px;
      position: relative;

      img {
        width: 260px;
        height: 260px;
      }

      p {
        position: absolute;
        bottom: 18px;
        left: 24px;
        font-size: 24px;
        font-family: Arial, Arial;
        font-weight: normal;
        color: #FFFFFF;
      }
    }

    .list:nth-child(4) {
      margin-right: 0;
    }
  }
}

.weekly-box {
  padding: 50px 107px 160px;

  .title {
    text-align: center;
    margin-bottom: 26px;
    font-size: 32px;
    font-family: Arial, Arial;
    font-weight: 900;
    color: #333333;
    line-height: 45px
  }

  .text {
    text-align: center;
    margin-bottom: 40px;
    font-size: 20px;
    font-family: ArialMT;
    color: #999999;
    line-height: 32px;
  }

  .itemBox {
    display: flex;

    .item {
      position: relative;
      margin-right: 200px;

      img {
        width: 382px;
        height: 536px;
      }

      .mumbai {
        position: absolute;
        max-width: 290px;
        bottom: 88px;
        right: -140px;
        padding: 27px 30px;
        box-sizing: border-box;
        background: #FFFFFF;
        box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.13);
        border-radius: 24px;

        .mumbai-bt {
          margin-bottom: 24px;
          padding-bottom: 24px;
          font-size: 24px;
          font-family: Arial, Arial;
          font-weight: normal;
          color: #333333;
          border-bottom: 1px solid #DAE3E9;
        }

        .mumbai-title {
          margin-bottom: 12px;
          font-size: 16px;
          font-family: Arial, Arial;
          font-weight: normal;
          color: #333333;
        }

        .mumbai-text {
          margin-bottom: 52px;
          font-size: 16px;
          font-family: ArialMT;
          color: #999999;
          line-height: 32px;
        }

        .btn {
          cursor: pointer;
          padding: 16px 35px;
          background: #00B3C0;
          border-radius: 28px;
          font-size: 16px;
          font-family: ArialMT;
          color: #FFFFFF;
          box-sizing: border-box;
        }
      }
    }
  }
}

.country-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 360px 120px;
  box-sizing: border-box;

  img {
    margin-right: 80px;
    width: 570px;
    height: 357px;
  }

  .right {
    .title {
      margin-bottom: 14px;
      font-size: 32px;
      font-family: Arial, Arial;
      font-weight: 900;
      color: #333333;
      line-height: 45px;
    }

    .text {
      margin-bottom: 40px;
      font-size: 20px;
      font-family: ArialMT;
      color: #999999;
      line-height: 32px;
    }

    .lineBox {
      display: flex;

      .item {
        width: 50%;
        margin: 0 24px 30px 0;
        padding: 30px;
        margin-right: 24px;
        background: #F7F7F7;
        border-radius: 8px;
        box-sizing: border-box;

        p {
          margin-bottom: 4px;
          font-size: 22px;
          font-family: Arial, Arial;
          font-weight: normal;
          color: #333333;
        }

        span {
          font-size: 16px;
          font-family: ArialMT;
          color: #00B3C0;
        }
      }

      .item:nth-child(2) {
        margin-right: 0;
      }
    }
  }
}
</style>
